import { motion, AnimatePresence } from "framer-motion";
import { useLoading } from "../hooks/useLoading";

export function Loading() {
  const { isLoading } = useLoading();

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm"
        >
          <motion.div
            initial={{ scale: 0.5 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.5 }}
            className="flex flex-col items-center space-y-4 rounded-lg bg-card p-6 shadow-xl"
          >
            <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
            <p className="text-sm font-medium text-foreground">Carregando...</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
